import { api } from "../lib/api";

interface DigitalNurseCallRequest {
	fullName: string;
	phoneNumber: string;
	clinicName?: string;
	language?: string;
}

interface DigitalNurseCallResponse {
	success: boolean;
	message: string;
	callInitiated: boolean;
}

/**
 * Request a digital nurse AI phone call
 */
export async function callDigitalNurse(
	data: DigitalNurseCallRequest,
): Promise<DigitalNurseCallResponse> {
	const response = await api.post<DigitalNurseCallResponse>(
		"/api/digital-nurse/call",
		data,
	);
	return response.data;
}
